// ============================================================
// SAGARELO REFRIGERAÇÃO — CONTEÚDO CENTRAL EDITÁVEL
// Edite textos, imagens, serviços, FAQ, depoimentos e contatos aqui.
// ============================================================
import {
  Wrench, Cable, Building2, Settings, Droplets, CircuitBoard,
  RefreshCcw, Cog, ClipboardCheck,
} from "lucide-react";

export const site = {
  name: "SAGARELO®",
  suffix: "REFRIGERAÇÃO",
  tagline: "CLIMATIZAÇÃO COM EXCELÊNCIA.",
  whatsapp: "5565996091184",
  whatsappDisplay: "(65) 99609-1184",
  email: "comercial@sagarelo.com",
  instagram: "https://instagram.com/Sagarelo0",
  instagramHandle: "@Sagarelo0",
  region: "CUIABÁ • VÁRZEA GRANDE",
  regionLong: "Cuiabá e Várzea Grande — MT",
  schedule: "ATENDIMENTO SOB AGENDAMENTO",
};

export const waMessages = {
  default: "Olá! Vim pelo site da Sagarelo Refrigeração e gostaria de solicitar um orçamento.",
  pmoc: "Olá! Vim pelo site da Sagarelo Refrigeração e gostaria de solicitar informações e orçamento para PMOC.",
  rapel: "Olá! Gostaria de solicitar orçamento para serviço de ar-condicionado em altura.",
  placas: "Olá! Gostaria de solicitar diagnóstico/reparo de uma placa inverter.",
  instalacao: "Olá! Gostaria de solicitar orçamento para instalação de ar-condicionado.",
  manutencao: "Olá! Gostaria de solicitar orçamento para manutenção de ar-condicionado.",
  higienizacao: "Olá! Gostaria de solicitar orçamento para higienização de ar-condicionado.",
  compressor: "Olá! Gostaria de solicitar orçamento para troca de compressor.",
  realocacao: "Olá! Gostaria de solicitar orçamento para desinstalação/realocação de ar-condicionado.",
};

export const waLink = (msg = waMessages.default) =>
  `https://wa.me/${site.whatsapp}?text=${encodeURIComponent(msg)}`;

export const nav = [
  { label: "Serviços", href: "#servicos" },
  { label: "Trabalho em Altura", href: "#altura" },
  { label: "Placas Inverter", href: "#inverter" },
  { label: "PMOC", href: "#pmoc" },
  { label: "Portfólio", href: "#portfolio" },
  { label: "Sobre", href: "#sobre" },
  { label: "Serviços e Valores", href: "/contratar" },
  { label: "FAQ", href: "#faq" },
];

export const hero = {
  microtitle: "ENGENHARIA DE CLIMATIZAÇÃO — CUIABÁ • MT",
  titleLines: ["CLIMATIZAÇÃO", "SEM LIMITES", "DE ALTURA."],
  highlightWord: "ALTURA.",
  subtitle:
    "Instalação e manutenção de ar-condicionado com soluções técnicas para apartamentos, condomínios e empresas.",
  tagsLine: "RAPEL • ANDAIME DE JANELA • MANUTENÇÃO • PLACAS INVERTER • PMOC",
  image: "/images/hero-rapel.jpg",
  primaryCta: "ORÇAMENTO VIA WHATSAPP",
  secondaryCta: "CONHECER SERVIÇOS",
  onlineQuote: {
    cta: "ORÇAMENTO ON-LINE NA HORA",
    titleA: "ORÇAMENTO",
    titleB: "ON-LINE NA HORA",
    message: "Escolha o serviço, selecione a forma de pagamento, veja os valores e taxas de juros conforme o número de parcelas, tudo na hora sem demora.",
    proceed: "PROSSEGUIR",
  },
};

export const tickerItems = [
  "RAPEL", "ANDAIME DE JANELA", "INSTALAÇÃO", "MANUTENÇÃO", "PLACAS INVERTER",
  "PMOC", "HIGIENIZAÇÃO", "DIAGNÓSTICO", "CLIMATIZAÇÃO",
];

export const positioning = {
  chapter: "01",
  microtitle: "ESPECIALISTAS EM ACESSO TÉCNICO",
  titleA: "ONDE O ACESSO É DIFÍCIL,",
  titleB: "A TÉCNICA FAZ A DIFERENÇA.",
  highlightWord: "TÉCNICA",
  description:
    "A Sagarelo atua onde a maioria não alcança: fachadas, sacadas, shafts e coberturas. Planejamento, equipamento certificado e execução precisa em cada serviço.",
  cards: [
    {
      num: "01",
      title: "RAPEL",
      desc: "Instalação e manutenção em fachadas com acesso por corda, sem necessidade de andaimes ou estruturas extras.",
      img: "/images/card-rapel.jpg",
    },
    {
      num: "02",
      title: "ANDAIME DE JANELA",
      desc: "Estrutura metálica de janela para serviços em altura com estabilidade, alcance e segurança operacional.",
      img: "/images/card-andaime.jpg",
    },
    {
      num: "03",
      title: "MANUTENÇÃO TÉCNICA",
      desc: "Preventiva e corretiva com diagnóstico preciso, ferramentas profissionais e procedimento padronizado.",
      img: "/images/card-manutencao.jpg",
    },
  ],
};

export const rotating = {
  microtitle: "PRECISÃO EM 360°",
  titleA: "TÉCNICA, EQUIPAMENTO",
  titleB: "E MÉTODO DE CAMPO.",
  text: "SAGARELO® • CLIMATIZAÇÃO EM ALTURA • RAPEL • ANDAIME DE JANELA • ",
  centerImage: "/images/circle-center.jpg",
  paragraph:
    "Cada serviço começa com avaliação técnica do acesso, do equipamento e da estrutura. O resultado é execução limpa, segura e dentro do prazo — em qualquer altura.",
  points: ["Avaliação prévia do local", "Equipamentos de segurança certificados", "Equipe especializada em altura"],
};

export const services = {
  chapter: "02",
  microtitle: "O QUE FAZEMOS",
  titleA: "SOLUÇÕES COMPLETAS",
  titleB: "EM CLIMATIZAÇÃO.",
  items: [
    { num: "01", icon: Wrench, title: "INSTALAÇÃO", desc: "Instalação de ar-condicionado split, piso-teto e multi-split em residências, apartamentos e empresas.", wa: waMessages.instalacao },
    { num: "02", icon: Cable, title: "INSTALAÇÃO POR RAPEL", desc: "Instalação em fachadas e locais de difícil acesso utilizando técnicas de rapel e ancoragem.", wa: waMessages.rapel },
    { num: "03", icon: Building2, title: "ANDAIME DE JANELA", desc: "Serviços em altura com andaime de janela metálico para condensadoras e fachadas.", wa: waMessages.rapel },
    { num: "04", icon: Settings, title: "MANUTENÇÃO", desc: "Manutenção preventiva e corretiva com diagnóstico técnico e procedimentos padronizados.", wa: waMessages.manutencao },
    { num: "05", icon: Droplets, title: "HIGIENIZAÇÃO", desc: "Higienização profissional de evaporadoras e condensadoras para qualidade do ar e eficiência.", wa: waMessages.higienizacao },
    { num: "06", icon: CircuitBoard, title: "PLACAS INVERTER", desc: "Diagnóstico e reparo eletrônico de placas inverter e convencionais em bancada.", wa: waMessages.placas },
    { num: "07", icon: RefreshCcw, title: "DESINSTALAÇÃO E REALOCAÇÃO", desc: "Desinstalação, reinstalação e realocação de evaporadoras e condensadoras.", wa: waMessages.realocacao },
    { num: "08", icon: Cog, title: "TROCA DE COMPRESSOR", desc: "Substituição de compressores com diagnóstico de causa raiz e testes de operação.", wa: waMessages.compressor },
    { num: "09", icon: ClipboardCheck, title: "PMOC", desc: "Plano de Manutenção, Operação e Controle para empresas e condomínios.", wa: waMessages.pmoc },
  ],
};

export const brands = {
  microtitle: "CREDENCIADO MULTIMARCAS",
  titleA: "ATENDEMOS TODAS",
  titleB: "AS MARCAS.",
  highlightWord: "AS MARCAS.",
  description: "Instalação, manutenção e reparo em equipamentos das principais fabricantes do mercado.",
  items: [
    { name: "Midea", logo: "/brands/midea.svg" },
    { name: "Springer", logo: "/brands/springer.svg" },
    { name: "Carrier", logo: "/brands/carrier.svg" },
    { name: "LG", logo: "/brands/lg.svg" },
    { name: "Samsung", logo: "/brands/samsung.svg" },
    { name: "Daikin", logo: "/brands/daikin.svg" },
    { name: "Gree", logo: "/brands/gree.svg" },
    { name: "Fujitsu", logo: "/brands/fujitsu.svg" },
    { name: "Elgin", logo: "/brands/elgin.svg" },
    { name: "Consul", logo: "/brands/consul.svg" },
    { name: "Philco", logo: "/brands/philco.svg" },
    { name: "Electrolux", logo: "/brands/electrolux.svg" },
    { name: "TCL", logo: "/brands/tcl.svg" },
    { name: "Panasonic", logo: "/brands/panasonic.svg" },
    { name: "Hitachi", logo: "/brands/hitachi.svg" },
  ],
};

export const heightWork = {
  chapter: "03",
  microtitle: "ACESSO POR CORDA E ESTRUTURA",
  titleA: "TRABALHO EM ALTURA",
  titleB: "EXIGE PRECISÃO.",
  highlightWord: "PRECISÃO.",
  image: "/images/hero-sagarelo.jpg",
  items: [
    "Rapel",
    "Andaime de janela",
    "Instalações em fachadas",
    "Movimentação de condensadoras",
    "Acesso técnico",
    "Planejamento",
    "Procedimentos de segurança",
  ],
  cta: "SOLICITAR AVALIAÇÃO",
};

export const inverter = {
  chapter: "04",
  microtitle: "ELETRÔNICA E DIAGNÓSTICO",
  titleA: "REPARO DE",
  titleB: "PLACAS INVERTER.",
  highlightWord: "PLACAS INVERTER.",
  description:
    "Diagnóstico eletrônico em bancada com instrumentos de medição, identificação de componentes defeituosos e reparo em nível de componente.",
  images: { main: "/images/inverter-main.jpg", secondary: "/images/circuit.jpg" },
  cards: [
    { icon: "ScanLine", title: "DIAGNÓSTICO", desc: "Análise de falhas e códigos de erro" },
    { icon: "CircuitBoard", title: "REPARO", desc: "Troca de componentes em bancada" },
    { icon: "Gauge", title: "TESTES", desc: "Medição e validação de funcionamento" },
    { icon: "Activity", title: "ANÁLISE ELETRÔNICA", desc: "Instrumentos e osciloscópio" },
    { icon: "Settings", title: "MANUTENÇÃO", desc: "Revisão e prevenção de falhas" },
  ],
  cta: "SOLICITAR DIAGNÓSTICO",
};

export const pmoc = {
  chapter: "05",
  microtitle: "GESTÃO DE CLIMATIZAÇÃO",
  titleA: "PMOC PARA EMPRESAS",
  titleB: "E CONDOMÍNIOS.",
  highlightWord: "CONDOMÍNIOS.",
  subtitle:
    "Organização, planejamento e acompanhamento da manutenção dos sistemas de climatização.",
  cards: [
    { title: "PLANEJAMENTO", desc: "Cronograma de manutenções alinhado à operação do seu estabelecimento." },
    { title: "INVENTÁRIO DOS EQUIPAMENTOS", desc: "Registro completo de cada aparelho, capacidade e localização." },
    { title: "MANUTENÇÃO PROGRAMADA", desc: "Visitas preventivas periódicas com execução padronizada." },
    { title: "REGISTRO DOS SERVIÇOS", desc: "Histórico documentado de cada intervenção realizada." },
    { title: "ACOMPANHAMENTO", desc: "Monitoramento contínuo do estado dos equipamentos." },
    { title: "GESTÃO DA CLIMATIZAÇÃO", desc: "Visão completa do parque de climatização em um só plano." },
  ],
  publics: ["Empresas", "Condomínios", "Escritórios", "Clínicas", "Lojas", "Estabelecimentos comerciais"],
  cta: "SOLICITAR ORÇAMENTO DE PMOC",
  note: "Dados de responsável técnico, registro profissional e ART/TRT podem ser adicionados aqui (campo editável).",
  form: {
    establishmentTypes: ["Empresa", "Condomínio", "Escritório", "Clínica", "Loja", "Outro"],
    unitCounts: ["1–5", "6–10", "11–20", "21–50", "51+"],
    equipmentTypes: ["Split", "Cassete", "Piso-teto", "VRF", "Outro"],
  },
};

export const whyUs = {
  chapter: "06",
  microtitle: "DIFERENCIAIS",
  titleA: "POR QUE ESCOLHER",
  titleB: "A SAGARELO?",
  highlightWord: "SAGARELO?",
  items: [
    "Especialização em difícil acesso",
    "Atendimento em apartamentos",
    "Rapel",
    "Andaime de janela",
    "Diagnóstico técnico",
    "Manutenção preventiva",
    "Manutenção corretiva",
    "Placas inverter",
    "Atendimento empresarial",
    "PMOC",
  ],
};

export const portfolio = {
  chapter: "07",
  microtitle: "TRABALHOS REALIZADOS",
  titleA: "NOSSO TRABALHO",
  titleB: "NA PRÁTICA.",
  filters: ["TODOS", "RAPEL", "INSTALAÇÕES", "MANUTENÇÃO", "ANDAIME", "PLACAS", "PMOC"],
  items: [
    { img: "/images/p-rapel-fachada.jpg", category: "RAPEL", title: "Instalação em fachada por rapel" },
    { img: "/images/p-rapel-cobertura.jpg", category: "RAPEL", title: "Acesso por corda em cobertura" },
    { img: "/images/p-rapel-cobertura-2.jpg", category: "RAPEL", title: "Rapel técnico em fachada" },
    { img: "/images/p-instalacao-eletrica.jpg", category: "INSTALAÇÕES", title: "Instalação elétrica de climatização" },
    { img: "/images/p-condensadora.jpg", category: "INSTALAÇÕES", title: "Condensadora em edifício residencial" },
    { img: "/images/p-manutencao.jpg", category: "MANUTENÇÃO", title: "Manutenção preventiva programada" },
    { img: "/images/p-andaime.jpg", category: "ANDAIME", title: "Serviço com andaime de janela" },
    { img: "/images/p-placa.jpg", category: "PLACAS", title: "Reparo de placa inverter em bancada" },
    { img: "/images/p-pmoc.jpg", category: "PMOC", title: "Gestão de climatização corporativa" },
  ],
};

export const beforeAfter = {
  chapter: "08",
  microtitle: "RESULTADO VISÍVEL",
  titleA: "ANTES",
  titleB: "E DEPOIS.",
  highlightWord: "DEPOIS.",
  description: "Arraste o controle e compare o resultado de uma higienização profissional.",
  before: "/images/antes-turbina.jpg",
  after: "/images/depois-turbina.jpg",
  beforeLabel: "ANTES",
  afterLabel: "DEPOIS",
};

export const processSteps = {
  chapter: "09",
  microtitle: "COMO TRABALHAMOS",
  titleA: "DO PRIMEIRO CONTATO",
  titleB: "À ENTREGA.",
  steps: [
    { num: "01", title: "CONTATO", desc: "Você chama no WhatsApp e descreve a necessidade." },
    { num: "02", title: "AVALIAÇÃO", desc: "Análise técnica do local, acesso e equipamento." },
    { num: "03", title: "EXECUÇÃO", desc: "Serviço realizado com método, EPIs e ferramentas profissionais." },
    { num: "04", title: "ENTREGA", desc: "Testes finais, orientações de uso e registro do serviço." },
  ],
};

export const authority = {
  microtitle: "AUTORIDADE TÉCNICA",
  titleA: "EXPERIÊNCIA TÉCNICA",
  titleB: "EM CAMPO.",
  image: "/images/industrial.jpg",
  videos: [
    { src: "/videos/autoridade-5.mp4", poster: "/videos/poster-5.jpg", label: "ANDAIME DE JANELA" },
    { src: "/videos/autoridade-4.mp4", poster: "/videos/poster-4.jpg", label: "RAPEL" },
    { src: "/videos/autoridade-6.mp4", poster: "/videos/poster-6.jpg", label: "HIGIENIZAÇÃO" },
    { src: "/videos/autoridade-7.mp4", poster: "/videos/poster-7.jpg", label: "MANUTENÇÃO" },
    { src: "/videos/autoridade-1.mp4", poster: "/videos/poster-1.jpg", label: "SERVIÇO EM CAMPO" },
    { src: "/videos/autoridade-2.mp4", poster: "/videos/poster-2.jpg", label: "TRABALHO EM ALTURA" },
    { src: "/videos/autoridade-3.mp4", poster: "/videos/poster-3.jpg", label: "CLIMATIZAÇÃO" },
  ],
  name: "Equipe Sagarelo", // EDITÁVEL — nome do responsável
  role: "Especialistas em climatização e acesso técnico", // EDITÁVEL
  description:
    "Atuação em campo em instalações e manutenções de climatização, com foco em serviços de difícil acesso, tecnologia inverter e gestão de manutenção para empresas e condomínios.",
  specialties: ["Rapel", "Andaime de janela", "Placas inverter", "PMOC"], // EDITÁVEL
  certNote: "Profissionais credenciados no CRT — Conselho Regional de Técnicos Industriais.",
};

// PLACEHOLDERS ilustrativos — substituir por depoimentos reais.
export const testimonials = {
  chapter: "10",
  microtitle: "DEPOIMENTOS",
  titleA: "QUEM CONTRATA",
  titleB: "CONTA A EXPERIÊNCIA.",
  items: [
    {
      name: "Ricardo M.",
      service: "Instalação em apartamento",
      text: "A condensadora precisou ser instalada na fachada e nenhuma empresa queria fazer. A Sagarelo resolveu com rapel, tudo limpo e seguro.",
      rating: 5,
    },
    {
      name: "Fernanda L.",
      service: "Higienização e manutenção",
      text: "Atendimento pontual, explicaram tudo que foi feito e o ar ficou como novo. Profissionalismo raro de encontrar.",
      rating: 5,
    },
    {
      name: "Administradora Central",
      service: "PMOC para condomínio",
      text: "Organizaram o inventário dos equipamentos e as manutenções passaram a ser programadas. Acabou a correria com chamados.",
      rating: 5,
    },
  ],
};

export const faq = {
  chapter: "11",
  microtitle: "DÚVIDAS",
  titleA: "PERGUNTAS",
  titleB: "FREQUENTES.",
  items: [
    { q: "Vocês trabalham em apartamentos?", a: "Sim. O atendimento em apartamentos é uma das nossas especialidades, incluindo instalação de condensadoras em fachadas, sacadas e áreas técnicas de difícil acesso." },
    { q: "Vocês fazem instalação por rapel?", a: "Sim. Quando o acesso convencional não é possível, realizamos a instalação e a manutenção com técnicas de rapel, ancoragem e equipamentos de segurança certificados." },
    { q: "Quando é necessário utilizar andaime de janela?", a: "O andaime de janela é indicado quando o serviço exige permanência prolongada, movimentação de equipamentos pesados ou quando o ponto de ancoragem para rapel não é viável. Avaliamos cada caso na visita técnica." },
    { q: "Vocês atendem condomínios?", a: "Sim. Atendemos condomínios residenciais e comerciais, incluindo contratos recorrentes, manutenção programada e PMOC." },
    { q: "Vocês trabalham com inverter?", a: "Sim. Realizamos instalação, manutenção e diagnóstico de equipamentos com tecnologia inverter de diversas marcas." },
    { q: "Vocês consertam placas inverter?", a: "Sim. Fazemos diagnóstico e reparo eletrônico de placas inverter em bancada, com medição, identificação de componentes defeituosos e testes de funcionamento." },
    { q: "Vocês fazem manutenção preventiva?", a: "Sim. A manutenção preventiva inclui limpeza, verificação de pressões, conexões elétricas, dreno e testes de operação — aumentando a vida útil e reduzindo o consumo de energia." },
    { q: "Vocês fazem PMOC?", a: "Sim. Elaboramos e executamos o Plano de Manutenção, Operação e Controle para empresas, condomínios, escritórios, clínicas e comércios, com inventário, cronograma e registros dos serviços." },
    { q: "Como solicitar orçamento?", a: "Pelo WhatsApp. Clique em qualquer botão de orçamento do site e você será direcionado com uma mensagem pronta. Respondemos com agilidade em horário comercial." },
    { q: "Quais cidades atendem?", a: "Atendemos Cuiabá e Várzea Grande, em Mato Grosso. Para outras localidades da região metropolitana, consulte disponibilidade pelo WhatsApp." },
  ],
};

export const finalCta = {
  titleA: "SEU AR-CONDICIONADO",
  titleB: "PRECISA DE UMA SOLUÇÃO?",
  highlightWord: "SOLUÇÃO?",
  text: "Instalação, manutenção, serviços em altura, placas inverter e soluções de climatização.",
  cta: "SOLICITAR ORÇAMENTO PELO WHATSAPP",
  image: "/images/fachada.jpg",
};

export const footerContent = {
  menu: [
    { label: "Serviços", href: "#servicos" },
    { label: "Rapel", href: "#altura" },
    { label: "Andaime", href: "#altura" },
    { label: "Placas Inverter", href: "#inverter" },
    { label: "PMOC", href: "#pmoc" },
    { label: "Portfólio", href: "#portfolio" },
    { label: "Contratar Instalação", href: "/contratar" },
    { label: "Contato", href: "#contato" },
  ],
};
